import { EnvelopeIcon, GlobeAltIcon, PaintBrushIcon, ServerStackIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { connect } from "react-redux";
import { getSiteSettings } from "src/actions/site";
import Tabs from "src/components/Shared/Tabs/Tabs";
import { H1 } from "src/components/Shared/Text/Headers";
import SiteEmailManager from "src/components/Site/SiteEmailManager";
import ServerMonitoringPanel from "src/components/ServerMonitoring/ServerMonitoringPanel";
import DomainSettings from "./DomainSettings";
import SiteThemeAndStyles from "./SiteThemeAndStyles";

const SiteSection = ({ me, ...props }) => {
  const isSuperAdmin = me?.type === "super" || me?.default_user;
  const tabs = [
    { name: "Themes & Styles", icon: PaintBrushIcon, component: <SiteThemeAndStyles /> },
    { name: "Email Provider", icon: EnvelopeIcon, component: <SiteEmailManager /> },
    { name: "Domain", icon: GlobeAltIcon, component: <DomainSettings /> },
    ...(isSuperAdmin ? [{ name: "Server Monitoring", icon: ServerStackIcon, component: <ServerMonitoringPanel /> }] : []),
  ];

  const loadSiteSettings = async () => await props.getSiteSettings();

  useEffect(() => {
    const ac = new AbortController();

    loadSiteSettings({}, ac);

    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <H1>Site Settings</H1>
      <Tabs tabs={tabs} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    site: state.site,
    me: state.auth.user,
  };
};

export default connect(mapStateToProps, { getSiteSettings })(SiteSection);
